module.exports = __webpack_public_path__ + "img/415.b273504c.png";